module.exports = __webpack_public_path__ + "static/media/CC20-AP160-12.3e7727c6.png";